var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTerms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60.889,
    height: 71.202,
    viewBox: "0 0 60.889 71.202",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bill-svgrepo-com",
    transform: "translate(-37.079)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11527",
    "data-name": "Path 11527",
    d: "M44.915,14.321a6.556,6.556,0,0,1,6.611-6.485c3.645,0,9.521,1.438,9.521,5.013V36.412c0,1.214.511,2.2-.726,2.2H57.74a2.756,2.756,0,0,1-4.179.3,2.759,2.759,0,0,1-3.923,0,2.76,2.76,0,0,1-4.723-1.942V14.321Z",
    transform: "translate(-6.746 -6.746)",
    fill: "#afb6bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11529",
    "data-name": "Path 11529",
    d: "M90.824,7.837h.112c-.082,0-.163,0-.244.006A1.163,1.163,0,0,1,90.824,7.837Z",
    transform: "translate(-46.157 -6.747)",
    fill: "#8cc63f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11530",
    "data-name": "Path 11530",
    d: "M99.061,14.321a6.556,6.556,0,0,0-6.61-6.485h45.488a6.556,6.556,0,0,1,6.61,6.485V74.66a2.22,2.22,0,0,1-2.241,2.2H101.3a2.22,2.22,0,0,1-2.241-2.2V14.321Z",
    transform: "translate(-47.672 -6.746)",
    fill: "#1b1d27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11531",
    "data-name": "Path 11531",
    d: "M103.64,74.66V14.321a6.556,6.556,0,0,0-6.61-6.485H92.45a6.556,6.556,0,0,1,6.61,6.485V74.66a2.22,2.22,0,0,0,2.241,2.2h4.58A2.22,2.22,0,0,1,103.64,74.66Z",
    transform: "translate(-47.671 -6.746)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9037",
    "data-name": "Group 9037",
    transform: "translate(59.168 21.433)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11533",
    "data-name": "Path 11533",
    d: "M317.55,208.547H304.109a1.09,1.09,0,0,1,0-2.18H317.55a1.09,1.09,0,0,1,0,2.18Z",
    transform: "translate(-288.125 -199.101)",
    fill: "#50fb56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11534",
    "data-name": "Path 11534",
    d: "M317.55,255.567H304.109a1.09,1.09,0,0,1,0-2.18H317.55a1.09,1.09,0,0,1,0,2.18Z",
    transform: "translate(-288.125 -239.583)",
    fill: "#50fb56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11535",
    "data-name": "Path 11535",
    d: "M317.55,302.587H304.109a1.09,1.09,0,0,1,0-2.18H317.55a1.09,1.09,0,0,1,0,2.18Z",
    transform: "translate(-288.125 -280.064)",
    fill: "#50fb56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11536",
    "data-name": "Path 11536",
    d: "M204.091,208.547h-7.084a1.09,1.09,0,1,1,0-2.18h7.084a1.09,1.09,0,0,1,0,2.18Z",
    transform: "translate(-195.917 -199.101)",
    fill: "#50fb56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11537",
    "data-name": "Path 11537",
    d: "M204.091,255.567h-7.084a1.09,1.09,0,0,1,0-2.18h7.084a1.09,1.09,0,0,1,0,2.18Z",
    transform: "translate(-195.917 -239.583)",
    fill: "#50fb56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11538",
    "data-name": "Path 11538",
    d: "M204.091,302.587h-7.084a1.09,1.09,0,1,1,0-2.18h7.084a1.09,1.09,0,0,1,0,2.18Z",
    transform: "translate(-195.917 -280.064)",
    fill: "#50fb56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11539",
    "data-name": "Path 11539",
    d: "M204.091,349.607h-7.084a1.09,1.09,0,1,1,0-2.18h7.084a1.09,1.09,0,0,1,0,2.18Z",
    transform: "translate(-195.917 -320.545)",
    fill: "#50fb56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11540",
    "data-name": "Path 11540",
    d: "M225.342,156.3H197.007a1.09,1.09,0,0,1,0-2.18h28.335a1.09,1.09,0,1,1,0,2.18Z",
    transform: "translate(-195.917 -154.122)",
    fill: "#50fb56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11541",
    "data-name": "Path 11541",
    d: "M225.342,398.718H197.007a1.09,1.09,0,1,1,0-2.18h28.335a1.09,1.09,0,1,1,0,2.18Z",
    transform: "translate(-195.917 -362.826)",
    fill: "#50fb56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11542",
    "data-name": "Path 11542",
    d: "M204.091,438.424h-7.084a1.09,1.09,0,0,1,0-2.18h7.084a1.09,1.09,0,0,1,0,2.18Z",
    transform: "translate(-195.917 -397.01)",
    fill: "#50fb56"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_11543",
    "data-name": "Path 11543",
    d: "M249.478,52.278c0,3.241,3.54,5.781,8.058,5.781s8.058-2.539,8.058-5.781-3.54-5.78-8.058-5.78S249.478,49.037,249.478,52.278Zm13.937,0c0,1.952-2.692,3.6-5.879,3.6s-5.879-1.649-5.879-3.6,2.692-3.6,5.879-3.6S263.415,50.327,263.415,52.278Z",
    transform: "translate(-182.862 -40.032)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11544",
    "data-name": "Path 11544",
    d: "M96.878,59.795a1.09,1.09,0,0,0,1.09-1.09V7.574A7.647,7.647,0,0,0,90.268,0H44.779a7.647,7.647,0,0,0-7.7,7.574v2.452a1.09,1.09,0,1,0,2.18,0V7.574a5.522,5.522,0,0,1,11.041,0v23.45a1.074,1.074,0,0,0-.181.191,1.666,1.666,0,0,1-2.529.184,1.09,1.09,0,0,0-1.549,0,1.665,1.665,0,0,1-2.059.248V25.736a1.09,1.09,0,1,0-2.18,0v5.912a1.655,1.655,0,0,1-.872.248,1.673,1.673,0,0,1-1.671-1.671V15.112a1.09,1.09,0,1,0-2.18,0V30.224a3.853,3.853,0,0,0,5.812,3.315,3.86,3.86,0,0,0,3.923,0,3.832,3.832,0,0,0,3.485.217V67.914A3.313,3.313,0,0,0,53.63,71.2H94.637a3.313,3.313,0,0,0,3.33-3.288V63.064a1.09,1.09,0,1,0-2.18,0v4.849a1.131,1.131,0,0,1-1.151,1.108H53.63a1.132,1.132,0,0,1-1.151-1.108V7.574a7.491,7.491,0,0,0-2.3-5.395H90.268a5.465,5.465,0,0,1,5.52,5.395V58.705A1.09,1.09,0,0,0,96.878,59.795Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerms);
export default __webpack_public_path__ + "static/media/terms.d231ac5e087e535db91f124f114be92b.svg";
export { ForwardRef as ReactComponent };